<template>
  <div
    v-if="$parent.allowPublishing || (showIndexBtn && $parent.allowSearchAdministration) || $parent.allowDeleting"
    class="card-block small-paddings bulk-btns"
  >
    <button v-if="$parent.allowPublishing" class="btn btn-primary btn-sm" @click="unpublishEmpty">
      Unpublish Empty <span ref="unpublishEmptyLoader" class="btn-loader" style="display: none;" />
    </button>
    <div class="hidden-area">
      <button v-if="$parent.allowPublishing" class="btn btn-primary btn-sm" @click="publish">
        Publish Choosen <span ref="bulkPublishLoader" class="btn-loader" style="display: none;" />
      </button>
      <button v-if="$parent.allowPublishing" class="btn btn-primary btn-sm" @click="unpublish">
        Unpublish Choosen <span ref="bulkUnpublishLoader" class="btn-loader" style="display: none;" />
      </button>
      <button
        v-if="showIndexBtn && $parent.allowSearchAdministration"
        class="btn btn-primary btn-sm"
        @click="addToIndex"
      >
        Add to Index <span ref="bulkSearchIndexLoader" class="btn-loader" style="display: none;" />
      </button>
      <button v-if="$parent.allowDeleting" class="btn btn-danger btn-sm" @click="deleteEntities">
        Delete Choosen <span ref="bulkDeleteLoader" class="btn-loader" style="display: none;" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    entityType: {
      type: String,
      default: '',
    },
    choosenEntities: {
      type: Array,
      default: () => [],
    },
    showIndexBtn: {
      type: Boolean,
      default: false,
    },
    unpublishEmptyEndpoint: {
      type: String,
      default: '',
    },
  },

  methods: {
    deleteEntities() {
      if (window.confirm('Do you really want to delete these entities?')) {
        const postFormData = new FormData();
        const { prefix } = this.$config.app_api;
        const $loader = $(this.$refs.bulkDeleteLoader);
        postFormData.append('namespace', this.$store.state.contentTypes.list[this.entityType].namespace);
        for (let i = 0; i < this.choosenEntities.length; i += 1) {
          postFormData.append('ids[]', this.choosenEntities[i]);
        }
        $loader.show();
        this.$apiHttp.post(`${prefix}content-types/bulk-delete`, postFormData).then(() => {
          this.$emit('clearChoosenEntities');
          $loader.hide();
          this.$parent.getSource();
        }).catch((error) => {
          $loader.hide();
          console.error('Bulk delete error', error);
        });
      }
    },
    addToIndex() {
      const postFormData = new FormData();
      const { prefix } = this.$config.app_api;
      const $loader = $(this.$refs.bulkSearchIndexLoader);
      for (let i = 0; i < this.choosenEntities.length; i += 1) {
        postFormData.append('ids[]', this.choosenEntities[i]);
      }
      $loader.show();
      this.$apiHttp.post(`${prefix}search/documents/${this.entityType}`, postFormData).then(() => {
        this.$emit('clearChoosenEntities');
        $loader.hide();
      }).catch((error) => {
        $loader.hide();
        console.error('Bulk delete error', error);
      });
    },
    publish() {
      if (window.confirm('Do you really want to publish these entities?')) {
        const postFormData = new FormData();
        const { prefix } = this.$config.app_api;
        const $loader = $(this.$refs.bulkPublishLoader);
        postFormData.append('namespace', this.$store.state.contentTypes.list[this.entityType].namespace);
        for (let i = 0; i < this.choosenEntities.length; i += 1) {
          postFormData.append('ids[]', this.choosenEntities[i]);
        }
        $loader.show();
        this.$apiHttp.post(`${prefix}content-types/publish`, postFormData)
          .then(() => {
            this.$emit('changePublishedBtns', true);
            this.$emit('clearChoosenEntities');
            $loader.hide();
          }).catch((error) => {
            $loader.hide();
            console.error('Bulk publish error', error);
          });
      }
    },
    unpublish() {
      if (window.confirm('Do you really want to unpublish these entities?')) {
        const postFormData = new FormData();
        const { prefix } = this.$config.app_api;
        const $loader = $(this.$refs.bulkUnpublishLoader);
        postFormData.append('namespace', this.$store.state.contentTypes.list[this.entityType].namespace);
        for (let i = 0; i < this.choosenEntities.length; i += 1) {
          postFormData.append('ids[]', this.choosenEntities[i]);
        }
        $loader.show();
        this.$apiHttp.post(`${prefix}content-types/unpublish`, postFormData)
          .then(() => {
            this.$emit('changePublishedBtns', false);
            this.$emit('clearChoosenEntities');
            $loader.hide();
          }).catch((error) => {
            $loader.hide();
            console.error('Bulk unpublish error', error);
          });
      }
    },
    unpublishEmpty() {
      if (window.confirm('Do you really want to delete empty entities?')) {
        const $loader = $(this.$refs.unpublishEmptyLoader);
        $loader.show();
        this.$apiHttp.post(`${this.$config.app_api.prefix}${this.unpublishEmptyEndpoint}`)
          .then(() => {
            $loader.hide();
          }).catch((error) => {
            $loader.hide();
            console.error('Bulk unpublish error', error);
          });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// BulkBtns.vue?d1a43842